import type { Direction } from '@consta/uikit/Popover'
import type { TextProps } from '@consta/uikit/Text'
import { Text } from '@consta/uikit/Text'
import type { TooltipProps } from '@consta/uikit/withTooltip'
import type { Nullable } from 'common/types'
import type { FC, MouseEventHandler, PropsWithChildren } from 'react'
import { useRef } from 'react'

import { TextWithDisablingTooltip } from './TextWithDisablingTooltip'

type EllipsingTextProps = TextProps & {
  direction?: Direction
  className?: string
  tooltipClassName?: string
  onDoubleClick?: MouseEventHandler
}

const isEllipsisActive = (element: HTMLDivElement): boolean =>
  element.offsetWidth < element.scrollWidth

/**
 * Красиво обрезается текст.
 *
 * Текст, не влезающий в блок, обрезается с добавлением в конце многоточия...
 * Весь текст отображается во всплывающей подсказке.
 *
 * @param props.className - отвечает за значение атрибута class элемента
 */
export const EllipsingText: FC<PropsWithChildren<EllipsingTextProps>> = ({
  className,
  children,
  direction,
  tooltipClassName,
  ...props
}) => {
  const nameRef = useRef<Nullable<HTMLDivElement>>(null)
  const isEllipsis = nameRef.current ? isEllipsisActive(nameRef.current) : false
  const tooltipContent = (
    <Text {...props} className={tooltipClassName}>
      {children}
    </Text>
  )

  const tooltipProps: TooltipProps = {
    direction,
    tooltipContent,
  }

  return (
    <TextWithDisablingTooltip
      ref={nameRef}
      className={className}
      {...props}
      truncate={true}
      tooltipProps={tooltipProps}
      disabled={!isEllipsis}>
      {children}
    </TextWithDisablingTooltip>
  )
}
